import React, { useState, useEffect } from "react";
import { ref, onValue, set } from "firebase/database";
import { db, auth } from "../firebaseConfig";
import Popup from "../components/WorkspacesPopup";
import "./Workspaces.css";

const Workspaces = () => {
  const [workspaceData, setWorkspaceData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const user = auth.currentUser;
    
    if (!user) {
      console.error("User not authenticated");
      return;
    }
  
    const dbRef = ref(db, "neoslide/workspaces");
  
    onValue(dbRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
  
        const workspacesArray = Object.values(data || {}).filter(
          (item) => typeof item === "string"
        );
  
        setWorkspaceData(workspacesArray);
      } else {
        console.log("No data available");
      }
    });
  }, []);

  const handleAddWorkspace = (newWorkspace, apiKey) => {
    if (!newWorkspace.trim()) return;

    const dbRef = ref(db, "neoslide/workspaces");

    onValue(
      dbRef,
      (snapshot) => {
        const existingWorkspaces = snapshot.exists() ? snapshot.val() : [];

        if (!existingWorkspaces.includes(newWorkspace)) {
          const updatedWorkspaces = [...existingWorkspaces, newWorkspace];
          set(ref(db, `neoslide/workspaces`), updatedWorkspaces)
            .then(() => {
              return set(ref(db, `neoslide/weatherConf/${newWorkspace}/apiKey`), apiKey);
            })
            .then(() => {
              alert("Workspace added successfully!");
              setIsPopupOpen(false);
            });
        }
      },
      { onlyOnce: true } 
    );
  };

  return (
    <div className="workspaces-container">
      <h2>Workspaces</h2>
      <button className="workspaces-container__button" onClick={() => setIsPopupOpen(true)}>
        + Add Workspace
      </button>
      <ul>
        {workspaceData?.map((workspace, index) => (
          <li key={index}>{workspace}</li>
        ))}
      </ul>
      <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} onSubmit={handleAddWorkspace} />
    </div>
  );
};

export default Workspaces;
